module.exports = __webpack_public_path__ + "a8ddf7b475c077ba474a26dd4c78bcf9.png";